export const DONATION_RHYTHM = "donationRhythm";
export const DONATION_TYPE = "donationType";
export const SPONSORSHIP_TYPE = "sponsorshipType";
export const PAYMENT_METHOD = "paymentMethod";


export const DONATION_TYPE_LABEL = "Spendenart";
export const DONATION_RHYTHM_LABEL = "Spendenrhythmus";
export const SPONSORSHIP_TYPE_LABEL = "Art der Patenschaft";
export const PAYMENT_METHOD_LABEL = "Zahlungsart";

export const IBAN = "iban";
export const ACCOUNT_HOLDER = "accountholder";
export const INSTITUTE = "institute";
export const BIC = "bic";
export const DONATOR_TYPE = "donatorType";
export const SALUTATION = "salutation";
export const PRIORITY = "priority";
export const EMAIL = "email";
export const COMPANY_NAME = "companyName";
export const FIRSTNAME = "firstname";
export const SURNAME = "surname";
export const STREET = "street";
export const EXTRA_ADDRESS_LINE = "extraAddressLine";
export const ZIP = "zip";
export const CITY = "city";
export const COUNTRY = "country";
export const PHONE = "phone";
export const BIRTHDAY = "birthday";
export const MESSAGE_TO_SOS = "messageToSos";
export const AMOUNT = "amount";
// GIFT kennzeichnet keine Geschenkprodukte, sondern ob eine Patenschaft verschenkt werden soll
export const GIFT = "gift";
export const GIFT_PERSONAL_GREETING = "giftPersonalGreeting";
export const GIFT_DONATOR_TYPE = "giftDonatorType";
export const GIFT_SALUTATION_TYPE = "giftSalutationType";
export const GIFT_COMPANY_NAME = "giftCompanyName";
export const GIFT_FIRSTNAME = "giftFirstname";
export const GIFT_SURNAME = "giftSurname";
export const GIFT_STREET = "giftStreet";
export const GIFT_EXTRA_ADDRESS_LINE = "giftExtraAddressLine";
export const GIFT_ZIP = "giftZip";
export const GIFT_CITY = "giftCity";
export const GIFT_COUNTRY = "giftCountry";
export const GIFT_CERTIFICATE_PDF_DATA = "giftCertificatePdfData";
export const PRODUCT_GREETING = "productGreeting";
export const PRODUCT_FIRSTNAME = "productFirstname";
export const PRODUCT_SURNAME = "productSurname";
export const PRODUCT_QUANTITY = "productQuantity";
export const CM_P_ID = "cmPId";
export const PRODUCT_ID = "productId";
export const NEWSLETTER = "newsletter";


export const MAX_DONATION_AMOUNT = 99999.99;
export const GERMAN_IBAN_PATTERN = "^DE\\d{2}\\s?([0-9a-zA-Z]{4}\\s?){4}[0-9a-zA-Z]{2}$";
export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const NAME_PATTERN = /^[^\d!@#$%^&*()_+={}\[\]:;"'<>,.?/\\|~`]+$/;
export const ZIP_PATTERN = /^[A-Za-z0-9\s\-]{3,10}$/;
export const CITY_PATTERN = /^[^\d!@#$%^&*()_+={}\[\]:;"<>,?/\\|~`]+$/;
export const MAX_LENGTH_MESSAGE_TO_SOS = 950;
export const MAX_LENGTH_PERSONAL_GREETING= 400;


export const COUNTRY_CODE_DEFAULT = "DE";
export const HEADLINE_DEFAULT = "Meine Unterstützung";
export const MIN_AMOUNT_DEFAULT = 1;
export const DATE_FORMAT_STANDARD = "YYYY-MM-DD";
